import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetChangeFailureRateAverage from "shared/DoraMetrics/useGetChangeFailureRateAverage";

import useDoraDateRange from "../useDateRange";

const useDoraChangeFailureRate = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { rate, loading, error, networkStatus } = useGetChangeFailureRateAverage({
    startTimeUnix: getUnixTime(startTime),
    endTimeUnix: getUnixTime(endTime),
  });

  const isLoading =
    (loading && typeof rate === "undefined") || networkStatus === NetworkStatus.refetch;

  return {
    rate,
    isLoading,
    error,
  };
};

export default useDoraChangeFailureRate;
